// extracted by mini-css-extract-plugin
module.exports = {"cardBody":"ChooseImageModal_cardBody__QKG2u","modalCard":"ChooseImageModal_modalCard__1B9D1"};